import type {QueryFunctionContext, UseQueryOptions} from '@tanstack/react-query'
import {queryOptions, useQuery} from '@tanstack/react-query'

import {type SupportedLocales, useLocale} from '@/lib/locale/locale'
import type {StoreApiResponse} from '@/models/storeModel'
import {getStore} from '@/services/storeService'

export function getStoreQueryKey(params: {storeId: string; locale: SupportedLocales}) {
  return ['store', params.storeId, params.locale] as const
}

export function getStoreQueryOptions<TData = StoreApiResponse, TError = Error>(
  params: {storeId: string; locale: SupportedLocales},
  options?: Omit<UseQueryOptions<StoreApiResponse, TError, TData>, 'queryKey' | 'queryFn'>,
) {
  return queryOptions({
    queryKey: getStoreQueryKey(params),
    queryFn: async ({signal}: QueryFunctionContext) => {
      const res = await getStore({storeId: params.storeId, locale: params.locale, signal})
      return res
    },
    ...options,
  })
}

export default function useStore(storeId: string) {
  const [locale] = useLocale()
  return useQuery(getStoreQueryOptions({storeId, locale}))
}
